import { Subject } from 'rxjs';

export interface BaseEventType {
    type: string;
    payload?: any;
}

export interface BaseEvent<Payload> {
    type: string;
    payload?: Payload;
}

export default class EventBus {
    public static getInstance(): EventBus {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }
        return EventBus.instance;
    }

    private static instance: EventBus;

    private eventSubject = new Subject<BaseEventType>();

    public get events() {
        return this.eventSubject.asObservable();
    }

    public post<T extends BaseEventType>(event: T): void {
        this.eventSubject.next(event);
    }
}

export const onPushEventBus = <T>(type: string, payload?: T) => {
    EventBus.getInstance().post({ type, payload });
};

export const EventBusName = {
    UPDATE_NEW_FEED: 'UPDATE_NEW_FEED',
    CHANGE_BRANCH: 'CHANGE_BRANCH',
    RECEIVE_SOCKET_WORK_CHAT: 'RECEIVE_SOCKET_WORK_CHAT',
    SELECT_SCHOOL_MODAL: 'SELECT_SCHOOL_MODAL',
}
